import { render } from "./FilterDepartment.vue?vue&type=template&id=8b9d92c6"
import script from "./FilterDepartment.vue?vue&type=script&lang=js"
export * from "./FilterDepartment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__